// Canonical aircraft USAGE set for V2. Single source of truth.
//
// This is aircraft USE (Pleasure & Business, Flying Club, Commercial, ...),
// NOT hull-coverage scope. Coverage Type (All Risk / Ground & Flight) is a
// separate per-aircraft axis and lives on Aircraft_on_Quote/Policy.Coverage_Type.
//
// Mirrors the Quotations.Aircraft_Usage picklist (16 values including -None-).
// The Zoho subform field is text, the dropdown is a convention. Values are
// written verbatim, so keep the strings exact. Kept in sync with the legacy
// AIRCRAFT_USE_PICKLIST in public/v1/index.html.
//
// TODO: promote to admin config (DB-backed, broker-editable) per the
// admin-configurable-rules principle, and have every surface fetch it.
export const AIRCRAFT_USE_OPTIONS = [
  'Pleasure & Business',
  'Instruction & Rental, including P&B',
  'Flying Club',
  'Commercial',
  'Industrial Aid',
  'Dual Instruction, including P&B',
  'Pipeline Patrol, including P&B',
  'Sales Demo, including P&B',
  'Skydiving, including P&B',
  'Storage Only',
  'Part 135, including P&B',
  'Glider Towing, including P&B',
  'Aerial Photo, including P&B',
  'Aerial Application, including P&B',
  'Other',
];
